module.exports = __webpack_public_path__ + "img/ic／8.af008e80.png";